import { render, staticRenderFns } from "./homePageCertifs.vue?vue&type=template&id=089c553e&"
import script from "./homePageCertifs.vue?vue&type=script&lang=js&"
export * from "./homePageCertifs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports